export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 0_00.1c4e1b4f.jpg";